var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_vm._v("welcome page")])}
var staticRenderFns = []

export { render, staticRenderFns }